import React, { useEffect, useState } from 'react';
import { LoadingState } from '@common/components/loading-state';

/*
 * This component is supposed to be a private one, hence it
 * should be used only by other generic components.
 * You may use the FileViewer component instead.
 */

export const PdfPreview = ({
  assetUrl,
  width = '100%',
  height = '100%',
}: {
  assetUrl: string;
  width?: number | string;
  height?: number | string;
}) => {
  const previewUrl = assetUrl.replace('?disposition=attachment', '');
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setIsLoading(false);
  }, [assetUrl]);

  return (
    <>
      {isLoading && <LoadingState className="pdf-preview__loader" />}
      <embed
        /* apparently it works */
        /* eslint-disable-next-line react/no-unknown-property */
        onLoad={() => setIsLoading(false)}
        src={previewUrl}
        className="wk-pdf-preview"
        style={{
          width: width,
          height: height,
          visibility: isLoading ? 'hidden' : 'visible',
        }}
      />
      <style jsx>{`
        :global(span.pdf-preview__loader.loading-state) {
          padding-left: 0;
        }
        .wk-pdf-preview {
          border-radius: 8px;
        }
      `}</style>
    </>
  );
};
